import { useMemo } from "react";
import styles from "./eyebrow-animated.module.css";

interface IEybrowAnimatedProps {
  phrases: string[];
  subhead?: string;
  colorOdd?: string;
  colorEven?: string;
  colorSubhead?: string;
  colorSubheadBackground?: string;
}

const animationDuration = 0.4;

const EyebrowAnimated = ({ phrases, subhead, colorOdd, colorEven, colorSubhead, colorSubheadBackground }: IEybrowAnimatedProps) => {

  const animatedPhrases = useMemo(() => phrases.map((phrase, index) => {
    const isOdd = index % 2 === 0;
    return (
      <span
        key={index}
        className={`${styles.phrase} ${isOdd ? styles.phraseOdd : styles.phraseEven}`}
        style={{ animationDelay: `${((index + 1) * animationDuration)}s`, color: isOdd ? colorOdd : colorEven }}
      >
        {phrase}
      </span>
    );
  }), [phrases]);

  const subHeadEle = useMemo(() => {
    if (!subhead) return null;
    return (
      <span
        className={styles.subhead}
        style={{ animationDelay: `${((phrases.length + 1) * animationDuration)}s`, color: colorSubhead, backgroundColor: colorSubheadBackground }}
      >
        {subhead}
      </span>
    );
  }, [subhead, phrases]);

  return (
    <div className={styles.eyebrow}>
      {animatedPhrases}
      {subHeadEle}
    </div>
  );
};

export default EyebrowAnimated; 